const forms = [
  {
    name: "Tax Type Details",
    options: [
      {
        name: "Tax Type Name",    
        type: "input",
        form: {
          type: "text",
          name: "name",
          placeholder: "Enter tax type name",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Tax Type Code",
        type: "input",
        form: {
          type: "text",
          name: "code",
          placeholder: "Enter tax type code",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Description",
        type: "input",
        form: {
          type: "text",
          name: "description",
          placeholder: "Enter tax type description",
          class: "",
          value: "",
          required: false,
        },
      },
    ],
  },
  {
    name: "Status",
    options: [
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          value: 1,
          placeholder: "Status",
          options: [
            {
              value: 1,
              label: "Active",
            },
            {
              value: 0,
              label: "Inactive",
            },
          ],
          required: true,
        },
      },
    ],
  },
];

export default forms;